export default __webpack_public_path__ + "static/media/sad_cloud.b1014cf7.svg";